<template>
  <div class="home-container">
    <div class="course-box">
      <div class="max-width-box">
        <div class="home-page-left">
          <span class="slogan"
            >Grow up your skills by online courses with Covey</span
          >
          <!-- <span class="sub-slogan">Covey is an interesting platform that will teach you in more an interactive way</span> -->
          <div class="search">
            <img :src="require('@/assets/icon/search.png')" />
            <el-input
              v-model="queryStr"
              placeholder="What do you want to learn？"
              @keyup.enter.native="search"
            ></el-input>
            <el-button @click.native="search">search</el-button>
          </div>
        </div>
      </div>
      <el-carousel
        arrow="never"
        :autoplay="false"
        height="100%"
        class="carousel-com"
      >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="home-page-right">
            <img :src="item.url" />
            <!-- <img :src="require('@/assets/img/home_img.png')" /> -->
            <!-- <img :src="require('@/assets/img/haibao1.png')" /> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="course-box-midle">
      <!-- <div class="title-box">
                <div class="main-title">
                    <span>Tutors </span>
                    <span>certified and starred</span>
                </div>
                <div class="sub-title">
                    <span>Over one million students gave a grade of 5 stars to their
                        tutor
                    </span>
                </div>
            </div>
            
            <RecommendTeachers :teacherList="teacherList"></RecommendTeachers>

            <div class="view-more">
                <el-button>VIEW MORE TEACHERS</el-button>
            </div> -->
      <div class="title-box">
        <div class="main-title">
          <span>Amazing </span>
          <span>courses</span>
        </div>
        <div class="sub-title">
          <span
            >Over one million students gave a grade of 5 stars to their
            tutor</span
          >
        </div>
      </div>
      <RecommendCourses
        style="margin-top: 16px"
        :courseList="courseList"
      ></RecommendCourses>

      <div class="view-more" @click="gotoCourse">
        <el-button>VIEW MORE COURSES</el-button>
      </div>
    </div>

    <div class="feedback-box">
      <div class="feedback-left" @click.stop="isInqury = !isInqury">
        Get in touch
      </div>
      <div class="feedback-right" v-if="isInqury">
        <h2>Get in touch</h2>
        <el-form
          :model="feedbackForm"
          ref="feedbackForm"
          :rules="feedbackFormRules"
        >
          <el-form-item prop="name">
            <el-input
              v-model="feedbackForm.name"
              placeholder="Your name"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input
              v-model="feedbackForm.email"
              placeholder="Your email"
            ></el-input>
          </el-form-item>
          <el-form-item prop="feedback"
            ><el-input
              v-model="feedbackForm.feedback"
              type="textarea"
              placeholder="Your inqury"
            ></el-input>
          </el-form-item>
          <el-form-item
            ><el-button @click="submitFeedback">Submit Inquiry</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RecommendTeachers from "../Component/RecommendTeachers";
import RecommendCourses from "../Component/RecommendCourses";
import { Md5ChangePass, scopeDomain, secreKey } from "@/utils/comm";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      queryStr: "",
      teacherList: [],
      courseList: [],
      bannerList: [],
      isInqury: false,
      feedbackForm: {},
      feedbackFormRules: {
        name: {
          required: true,
          message: "Please fill in your name.",
          trigger: "blur",
        },
        email: {
          required: true,
          message: "Please fill in your email.",
          trigger: "blur",
        },
        feedback: {
          required: true,
          message: "Please fill in your feedback.",
          trigger: "blur",
        },
      },
    };
  },
  components: {
    RecommendTeachers,
    RecommendCourses,
  },
  computed: {
    ...mapState({
      appName: (state) => state.app.appName,
      collapse: (state) => state.app.collapse,
      navTree: (state) => state.menu.navTree,
      userInfo: (state) => state.app.userInfo,
      schoolId: (state) => state.app.schoolId,
    }),
    mainTabs: {
      get() {
        return this.$store.state.tab.mainTabs;
      },
      set(val) {
        this.$store.commit("updateMainTabs", val);
      },
    },
    mainTabsActiveName: {
      get() {
        return this.$store.state.tab.mainTabsActiveName;
      },
      set(val) {
        this.$store.commit("updateMainTabsActiveName", val);
      },
    },
  },
  watch: {
    $route: "handleRoute",
    schoolId: function (newVal, oldVal) {
      this.getRecommendTeachers();
      this.getRecommendCourses();
    },
  },
  created() {
    let { status, token, message } = this.$route.query;
    if (status === "0" && token) {
      //登录成功
      Cookies.set(scopeDomain.name, token, {
        expires: 3,
        domain: scopeDomain.path,
      }); //设置cookie
      this.$store.commit("setToken", token);
      this.autoLogin();
    } else if (status === "400") {
      this.$message.error(message);
    }
    this.$nextTick(() => {
      this.handleRoute(this.$route);
      this.getRecommendTeachers();
      this.getRecommendCourses();
      this.getBannerList();
    });
  },
  methods: {
    autoLogin() {
      this.$api.comApi.getUserInfo().then((res) => {
        if (res.status === "0") {
          this.$store.commit("handleUserInfo", res.data || {}); // 绑定用户信息
          this.$store.commit("SET_USERINFO", res.data || {}); // 绑定用户信息
          this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
          this.$store.commit("onCallback", true);
          this.$router.push("/"); // 登录成功，跳转到对应路由
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 路由操作处理
    handleRoute(route) {
      // console.log("this.$route.query==", this.$route.query);
    },
    search() {
      if (!this.queryStr) {
        return;
      }
      this.$router.push({
        path: "/search",
        query: {
          source: "home_banner",
          query: this.queryStr,
        },
      });
    },
    //获取推荐教师
    getRecommendTeachers() {
      this.$api.courseApi
        .getRecommendTeachers({ schoolId: this.schoolId })
        .then((res) => {
          if (res.status === "0") {
            this.teacherList = res.data.rows;
          }
        });
    },
    //获取推荐课程
    getRecommendCourses() {
      this.$api.courseApi
        .getRecommendCourses({ schoolId: this.schoolId })
        .then((res) => {
          if (res.status === "0") {
            res.data.rows.forEach((item) => {
              item.courseImg = JSON.parse(item.courseImg || "[]");
            });
            this.courseList = res.data.rows;
          }
        });
    },
    // 获取循环的海报
    getBannerList() {
      this.$api.comApi.getBannerList().then((res) => {
        if (res.status === "0") {
          this.bannerList = res.data.rows;
        }
      });
    },
    gotoCourse() {
      this.$router.push("/course");
    },
    async submitFeedback() {
      this.$refs["feedbackForm"].validate(async (valid) => {
        if (!valid) {
          return;
        }
        const { status, message } = await this.$api.userApi.submitFeedback(
          this.feedbackForm
        );
        if (status === "0") {
          this.$refs["feedbackForm"].resetFields();

          this.$notify({
            type: "success",
            message: "Thank you for your feedback!",
            position: "bottom-right",
            duration: 10000,
            customClass: "home-feedback_notify",
          });
        }
        // this.$notify({
        //   type: status === "0" ? "success" : "error",
        //   message: message,
        // });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/utils/vw.scss";
$navColor: #fff;
.home-container {
  .course-box {
    height: auto;

    transform: translate(0, 0);
    .carousel-com {
      height: vw(560);
      // /deep/ .el-carousel__item {
      //     background-image: url("../../../assets/img/shading.png");
      //     background-repeat: no-repeat;
      //     background-position: -512px 63px;
      // }
      /deep/ .el-carousel__indicators {
        margin-bottom: vw(24);
        .is-active .el-carousel__button {
          opacity: 1;
          background: rgba(0, 0, 0, 0.6);
        }
        .el-carousel__button {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          opacity: 1;
          background: rgba(0, 0, 0, 0.16);
        }
      }
    }
    .home-page-left {
      height: auto;
      z-index: 3;
      position: fixed;
      width: vw(600);
      display: flex;
      flex-direction: column;
      // margin-left: vw(178);
      margin-top: vh(190);

      .slogan {
        font-weight: 600;
        color: #201002;
        line-height: vw(60);
        font-size: vw(36);
        width: vw(580);
        // min-width: 580px;
        // min-height: 225px;
        -webkit-text-stroke: 1px #201002;
        display: flex;
        flex-wrap: wrap;
      }
      .sub-slogan {
        font-size: vw(24);
        width: vw(520);
        color: #7e8088;
        line-height: vh(38);
        margin-top: vh(23);
      }
      .search {
        width: vw(400);
        margin-top: vh(40);
        background: #ffffff;
        border-radius: 8px;
        height: vw(56);
        padding: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;

        box-sizing: border-box;
        img {
          margin-left: 8px;
          margin-right: 15px;
        }
        .el-button {
          background: #f48c06;
          height: 100%;
          border-radius: 8px;
          border: none;
          padding: 8px;
          color: #ffffff;
          font-weight: 600;
          line-height: vw(28);
          font-size: vw(16);
          display: flex;
          align-items: center;
        }
        /deep/ .el-input__inner {
          border: none;
          font-size: vw(16);
          color: #464646;
          line-height: vw(38);
          height: 100%;
        }
      }
    }
    .home-page-right {
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .course-box-midle {
    margin-top: 24px;
    .title-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-wrap: nowrap;
      .main-title {
        width: auto;
        font-weight: 500;
        font-size: vw(36);
        span:nth-child(1) {
          color: #0a033c;
          -webkit-text-stroke: 1px #0a033c;
        }
        span:nth-child(2) {
          color: #f48c06;
          -webkit-text-stroke: 1px #f48c06;
        }
      }
      .sub-title {
        width: vw(560);
        margin-top: vw(16);
        color: #696984;
        line-height: vw(40);
        font-size: vw(24);
        text-align: center;
      }
    }
    .view-more {
      margin: vw(40) 0 0 0;
      padding: 0 0 vw(96) 0;
      text-align: center;
      .el-button {
        width: vw(312);
        height: vw(48);
        background: #f48c06;
        border-radius: 32px;
        color: #ffffff;
        line-height: vw(20);
        font-weight: 600;
        font-size: vw(20);
        border: none;
      }
    }
  }
  .feedback-box {
    // min-height: 550px;
    display: flex;
    flex-direction: row;
    position: fixed;
    top: 10vh;
    right: 0;
    min-height: 80vh;
    align-items: flex-end;
    // width: 500px;
    z-index: 9999;
    .feedback-left {
      color: #ffffff;
      width: 50px;
      cursor: pointer;
      height: 220px;
      display: flex;
      font-size: 21px;
      transform: scale(-1);
      font-style: normal;
      text-align: center;
      align-items: center;
      font-weight: bold;
      line-height: 26px;
      border-radius: 0px 15px 15px 0px;
      justify-content: space-around;
      background-color: #3b3844;
      writing-mode: vertical-rl;
    }
    .feedback-right {
      width: 400px;
      height: 100%;
      display: flex;
      padding: 10px 20px;
      box-shadow: 0px 0px 30px 0px #3b3844;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: space-evenly;
      background-color: #ffffff;
      border-top-left-radius: 10px;
      /deep/ .el-textarea__inner {
        height: 100px !important;
      }
      /deep/ .el-button {
        width: 100%;
        height: 42px;
        background: #f48c06;
        border-radius: 32px;
        color: #ffffff;
        font-weight: 600;
        border: none;
        &:hover {
          opacity: 0.54;
        }
      }
    }
  }
}
</style>